
<mat-card  [class.error]="item.title==''">
    <div class="container">
        <div>Title</div>
        <div class="number"># {{item.number}}</div>
    </div>

    <mat-card-content>
        <mat-form-field class="title" appearance="outline">
            <input [class]="titleClassForSize" (input)="checkTitleLength($event.target.value)" (blur)="save()" [(ngModel)]="item.title" matInput aria-label="Title">
            <button class="update-title" matSuffix (click)="generateDynamic()" mat-raised-button>Update Title</button>
        </mat-form-field>
        

        <mat-form-field class="description" appearance="outline">
            <mat-label>Description/History</mat-label>
            <textarea (blur)="save()" [(ngModel)]="item.description" matInput rows="5"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="new-comment">
            <textarea matInput
            cdkTextareaAutosize
            #newcomment
            #autosize="cdkTextareaAutosize"
            placeholder="write comment"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows=""></textarea>
        </mat-form-field>
        <div class="add-comment"><button mat-raised-button class="add-comment" (click)="addLog(newcomment.value);newcomment.value=''">Add Comment</button></div>

        <div class="log-entries">
            <div *ngFor="let log of item.log.slice().reverse()" class="entry">
                <div class="text">
                    {{log.text }}
                </div>
                <div class="date">
                    {{log.date | date:'M/d/yy, h:mm a'}}
                </div>
            </div>
            <div *ngIf="this.item.log.length > 0" class="reset">
                <span (dblclick)="resetLog()">Clear</span>
            </div>
        </div>
    </mat-card-content>
</mat-card>